import { Box, Space } from '@mantine/core';
import {
  useGetDiscussionCommentDataInDiscovery,
  useGetDiscussionDataInDiscovery,
} from '@/features/Discovery/Modal/DiscoveryContentDetailModal/hook/api';

import { ACTIVITY_TYPE } from '@/consts/Activity';
import CodeBlock from '@/components/CodeBlock';
import CommentContainer from '@/features/Common/components/Comment';
import DMText from '@/components/DMText';
import VoteComponent from '@/features/Discussion/VoteComponent';
import { createDiscoveryModalStyles } from '@/features/Discovery/discovery.style';
import themeVariables from '@/styles/themeVariables';

const VoteBody = ({ id }) => {
  const { classes } = createDiscoveryModalStyles();

  const {
    data: topicData,
    refetch: refetchTopicData,
    isLoading,
  } = useGetDiscussionDataInDiscovery(id);
  const { data: comments, refetch: refetchComment } =
    useGetDiscussionCommentDataInDiscovery(id);

  const { item } = topicData || {};

  if (isLoading) {
    return <Space my={600} />;
  }

  return (
    <Box mt={16}>
      <DMText
        className={classes.bodyVoteTitle}
        dColor={themeVariables.darkMode.strong}
      >
        옵션 A
      </DMText>
      <CodeBlock
        code={item?.options[0].code}
        language={item?.options[0].code_language}
        shadow
      />
      <VoteComponent
        discussionId={item?.id}
        options={item?.options}
        side={item?.my_vote_option_id}
        refetch={refetchTopicData}
      />
      <DMText
        className={classes.bodyVoteTitle}
        dColor={themeVariables.darkMode.strong}
      >
        옵션 B
      </DMText>
      <CodeBlock
        code={item?.options[1].code}
        language={item?.options[1].code_language}
        shadow
      />
      <Box p={'84px 12px 24px'}>
        <CommentContainer
          topicData={topicData}
          comments={comments}
          refetchTopicData={refetchTopicData}
          refetchComment={refetchComment}
          type={ACTIVITY_TYPE.discussion}
        />
      </Box>
    </Box>
  );
};

export default VoteBody;
